import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Image, Segmented, Space } from 'antd';
import {WindowRounded, ViewModuleRounded, ViewCompactRounded, AppsRounded, FileCopyRounded} from "@mui/icons-material";
import CopyText from "../../Components/Text/CopyText";

const mapSizeToDimensions = (size)=>{
    switch (size) {
        case 'lg':
            return [180, 180];
        case 'md':
            return [140, 140];
        case 'sm':
            return [100, 100];
        default:
            return [140, 140];
    }
}

const SizeIcon = ({ size }) => (
    size === 'lg' ? <WindowRounded/> :
        size === 'md' ? <ViewModuleRounded/> :
            size === 'sm' ? <AppsRounded/> :
                null

);

const ImageGrid = ({ imageUrls, sizes=['lg', 'md', 'sm'], gridGutter = [64, 64],}) => {
    const [thumbnailSize, setThumbnailSize] = useState(sizes[0]);
    const [imageWidth, imageHeight] = mapSizeToDimensions(thumbnailSize);


    return (
        <Card bordered={false}
              title={
                <Segmented
                    options={sizes.map(size => ({ label: <SizeIcon size={size}/>, value: size }))}
                    value={thumbnailSize}
                    onChange={setThumbnailSize}
                />}
        >
            <Row justify={'center'} gutter={gridGutter}>
                {imageUrls.map((url, index) => (
                    <Col key={index} style={{ marginBottom: gridGutter }}>
                        <Card
                            className={'gapless'}
                            hoverable
                            bordered={false}
                            style={{ width: imageWidth, height: imageHeight, overflow: 'hidden' }}
                            bodyStyle={{ padding: 0 }}  // Removes padding inside the card if any
                            cover={
                                <Image src={url} width={imageWidth} height={imageHeight}/>
                            }
                        />
                        <Space>
                            <CopyText style={{color: "#C5D6E5"}} text={url}/>
                        </Space>
                    </Col>
                ))}
            </Row>
        </Card>
    );
};

export default ImageGrid;
